import { createAsyncThunk } from '@reduxjs/toolkit';

export const allChannelsFetched = createAsyncThunk(
  'channels/allChannelsFetched',
  async (response, { rejectWithValue }) => {
    return response.error_code ? rejectWithValue({ errorCode: response.error_code }) : response;
  },
);
